import { useEffect, useState } from "react";
import { Phone, X } from "lucide-react";
import api from "@/utils/api";

const SecurityPopup = () => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    nom: "",
    telephone: "",
    email: "",
    commerce: "",
    besoin: "",
    urgence: "standard",
  });
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    const dismissed = localStorage.getItem("fastalu_security_popup");
    if (dismissed) return;
    const timer = setTimeout(() => setOpen(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    localStorage.setItem("fastalu_security_popup", "dismissed");
    setOpen(false);
  };

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = async () => {
    if (!formData.nom || !formData.telephone || !formData.email) {
      setStatus("error");
      return;
    }
    setStatus("sending");
    try {
      await api.post("/api/leads", {
        source_page: "popup-securite",
        type_demande: formData.urgence === "immediat" ? "urgence" : "devis",
        service: "Sécurité commerce",
        nom: formData.nom,
        telephone: formData.telephone,
        email: formData.email || "",
        description: `Commerce: ${formData.commerce}. Besoin: ${formData.besoin}. Urgence: ${formData.urgence}.`,
        consentement: true,
      });
      setStatus("sent");
    } catch (error) {
      setStatus("error");
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" data-testid="security-popup">
      <div className="bg-white rounded-sm w-[360px] border border-brand-blue/15">
        <div className="flex items-center justify-between bg-brand-red text-white px-4 py-3">
          <h3 className="text-sm uppercase" data-testid="security-popup-title">
            Sécurité magasin / commerce
          </h3>
          <button onClick={handleClose} data-testid="security-popup-close">
            <X size={16} />
          </button>
        </div>
        <div className="p-4 space-y-3">
          <input
            className="w-full border border-brand-blue/15 rounded-sm px-3 py-2 text-sm"
            placeholder="Nom"
            value={formData.nom}
            onChange={handleChange("nom")}
            data-testid="security-popup-name"
          />
          <input
            className="w-full border border-brand-blue/15 rounded-sm px-3 py-2 text-sm"
            placeholder="Téléphone"
            value={formData.telephone}
            onChange={handleChange("telephone")}
            data-testid="security-popup-phone"
          />
          <input
            className="w-full border border-brand-blue/15 rounded-sm px-3 py-2 text-sm"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange("email")}
            data-testid="security-popup-email"
          />
          <select
            className="w-full border border-brand-blue/15 rounded-sm px-3 py-2 text-sm"
            value={formData.commerce}
            onChange={handleChange("commerce")}
            data-testid="security-popup-commerce"
          >
            <option value="">Type de commerce</option>
            <option value="tabac">Tabac</option>
            <option value="boutique">Boutique</option>
            <option value="superette">Supérette</option>
            <option value="autre">Autre</option>
          </select>
          <select
            className="w-full border border-brand-blue/15 rounded-sm px-3 py-2 text-sm"
            value={formData.besoin}
            onChange={handleChange("besoin")}
            data-testid="security-popup-besoin"
          >
            <option value="">Besoin principal</option>
            <option value="rideau">Rideau métallique</option>
            <option value="vitrage">Vitrage / vitrine</option>
            <option value="alarme">Alarme / caméra</option>
          </select>
          <select
            className="w-full border border-brand-blue/15 rounded-sm px-3 py-2 text-sm"
            value={formData.urgence}
            onChange={handleChange("urgence")}
            data-testid="security-popup-urgence"
          >
            <option value="standard">Urgence standard</option>
            <option value="immediat">Urgence 24h/24</option>
          </select>
          <button
            onClick={handleSubmit}
            className="w-full bg-brand-red text-white rounded-full py-2 text-xs uppercase font-semibold"
            data-testid="security-popup-submit"
          >
            {status === "sending" ? "Envoi..." : "Demander un devis"}
          </button>
          {status === "sent" && (
            <p className="text-xs text-brand-blue" data-testid="security-popup-success">
              Merci ! Nous revenons vers vous rapidement.
            </p>
          )}
          {status === "error" && (
            <p className="text-xs text-brand-red" data-testid="security-popup-error">
              Merci de renseigner nom, téléphone et email.
            </p>
          )}
          <a
            href="tel:0184160307"
            className="w-full border border-brand-blue/40 rounded-full py-2 text-xs uppercase font-semibold flex items-center justify-center gap-2"
            data-testid="security-popup-call"
          >
            <Phone size={14} />
            Appelez maintenant
          </a>
        </div>
      </div>
    </div>
  );
};

export default SecurityPopup;
